import Alert from 'react-bootstrap/Alert'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
    return (
        <Alert variant="warning">
            <Alert.Heading className="h5">Stránka nenalezena</Alert.Heading>
            <p className="mb-0">
                Požadovaná stránka neexistuje. <Link to="/">Zpět na úvod</Link>
            </p>
        </Alert>
    )
}
